import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Questions, SelectedOptionList } from 'src/app/common-class/questions';
import { Group, Matrix } from 'src/app/common-class/pages';
import { Answers } from 'src/app/common-class/answers';
import { tick } from '@angular/core/testing';
import { CommonLogic } from 'src/app/common-logic/common-logic';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { max } from 'rxjs/operators';
import { PreviewData } from 'src/app/common-class/survey';
import { SurveyMessages } from 'src/app/common-class/survey-messages';
// import { $ } from 'protractor';
declare var $: any;

@Component({
  selector: 'app-matrix-grid',
  templateUrl: './matrix-grid.component.html',
  styleUrls: ['./matrix-grid.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class MatrixGridComponent implements OnInit, OnChanges {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() groups: Group[];
  @Input() matrix: Matrix;
  @Input() isSubmitted: boolean;
  @Input() isMobile: boolean;
  @Input() DropDown:string;
  @Input() isNewParticipationButton: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  firstQuestion: Questions;
  isNgAfter: boolean;
  count: number = 0;

  checkDrillDown: number = 0;
  prevValue: any;

  questionsArray: any;
  isEx: boolean;
  dropDownCount:number;
  MatrixQCount:number;
  isNewParticipation: boolean;
  surveyFormat: number;
  newParticipationBtnText: string;
  isAutoScroll: boolean;
  isAnsChange: boolean = false;
  isSearchableDD: boolean = false;
  resetPageSub: any;
  isDisplayedPipeMessage: boolean;
  isAnswerPipingSubChar: boolean;
  isStandAloneGrid: boolean = false;
  MDDdropDownCount:number;
  Nomatchfound: string;
  surveyMessages: SurveyMessages;

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    if (change != undefined) {
      let curVal = JSON.stringify(change.currentValue);
      let preVal = JSON.stringify(change.previousValue);

      if (curVal != preVal && preVal != undefined) {
        //this.questions = JSON.parse(this.JsonData);
        //this.questions = this.questions.filter(e => e.population_type != 2 && e.population_type != 5);
        this.onLoadFilterObject();
        this.MDDdropDownCount = this.service.getMDDdropDownCount();
        if (this.questions.length > 0) {

          if (this.matrix.isBranchEnabled) {
            this.BranchingQuestionsHandling(true);
          }

          this.SortQuestions(false);

          //  Issue No.  122857 : [ANG] Show hide Grid sub question does not get randomize if QDL is applied. - Technical Difficullty
          // if (this.groups[0].answer_style == 2) {
          //   if (this.isMobile) {
          //     this.questionsArray = CommonLogic.RandomQuestionsHandlingMatrixMobile(this.questionsArray);
          //   } else {
          //     this.questionsArray = CommonLogic.RandomQuestionsHandling(this.questionsArray);
          //   }
          //   // Make Original Question Sequence Based on Random Question Sequence
          //   let newQuestions = [];
          //   for (var i = 0; i < this.questionsArray.length; i++) {
          //     newQuestions = newQuestions.concat(this.questionsArray[i]);
          //   }
          //   this.questions = newQuestions;
          // }

          this.ngAfterViewInit();
          this.isNgAfter = true;
          this.count = 0;
        }
      }
    }
  }

  constructor(private service: ParticipationDataService, private changeDetect: ChangeDetectorRef,
    private previewData: PreviewData) {
  }

  ngOnInit() {
    if (this.questions == null) {
      this.isEx = this.service.getIsEx();
      this.surveyMessages= this.service.getSurveyMessages();
      //this.questions = JSON.parse(this.JsonData);
      //this.questions = this.questions.filter(e => e.population_type != 2 && e.population_type != 5);
      this.onLoadFilterObject();
      this.MDDdropDownCount = this.service.getMDDdropDownCount();
      this.Nomatchfound= this.service.getSurveyMessages().Participation_Nomatchfound;
      if (this.questions.length > 0) {

        if (this.questions.filter(e => (e.qtype == "GD" || e.qtype=="RW") && e.Answers.length > (this.MDDdropDownCount -1)).length > 0) {
          this.isSearchableDD = true;
        }
        // for (let i = 0; i < this.groups.length; i++) {

        //   let questions = this.questions.filter(e => e.group_no == this.groups[i].group_no);

        //   if (questions.length > 0) {
        //     if (questions[0].answer_style == 2) {
        //       questions = CommonLogic.RandomQuestionsAnswerHandling(questions);

        //       for (let j = 0; j < questions.length; j++) {
        //         let qn = this.questions.find(e => e.UniqueNumber == questions[j].UniqueNumber);

        //         let index = this.questions.indexOf(qn);
        //         this.questions[index] = questions[j];
        //       }
        //     }
        //   }
        // }

        this.dropDownCount = this.service.getdropDownCount();
        if (this.matrix.isBranchEnabled) {
          this.BranchingQuestionsHandling(true);
        }

        // let fstQn
        // fstQn = this.questions[0];
        // if (fstQn != undefined && fstQn != null) {
        //   this.firstQuestion = fstQn;
        // }

        this.SortQuestions();

        // if (this.groups[0].answer_style == 2) {
        //   if (this.isMobile) {
        //     this.questionsArray = CommonLogic.RandomQuestionsHandlingMatrixMobile(this.questionsArray);
        //   } else {
        //     this.questionsArray = CommonLogic.RandomQuestionsHandling(this.questionsArray);
        //   }
        //   // Make Original Question Sequence Based on Random Question Sequence
        //   let newQuestions = [];
        //   for (var i = 0; i < this.questionsArray.length; i++) {
        //     newQuestions = newQuestions.concat(this.questionsArray[i]);
        //   }
        //   this.questions = newQuestions;
        // }

        // let imgQn
        // if(this.isEx)
        // {
        //   //this.isDisplayQno = true;
        //   imgQn = this.questions.find(e => e.sub_qno == 1 || e.population_type !=5);
        // }
        // else
        // {
        //   imgQn = this.questions.find(e => e.sub_qno == 1);
        // }
        // if (imgQn != undefined && imgQn != null) {
        //   this.imgQuestion = imgQn;
        // }

        // if(this.matrix.QPos == 0){
        //   this.matrixSubQ_first = true;
        // } else if(this.matrix.QPos == this.groups.length){
        //   this.matrixSubQ_last = true;
        // }
        this.MatrixQCount = this.questions.length;
        this.isNewParticipation = this.service.isNewParticipation;
        this.surveyFormat = this.service.surveyFormat;
        this.newParticipationBtnText = this.service.newParticipationBtnText;
        this.isAutoScroll = this.service.isAutoScroll;
      }
    }
  }

  ngAfterViewInit() {

    if (window.navigator.userAgent.indexOf("Chrome") != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
      // $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    }

    if (this.questions.length == 0) {
      return;
    }

    if (((this.questions[0].isGroupRule &&  this.questions[0].isCQHide)||(this.questions[0].isNOGroupRule &&  this.questions[0].isGroupCQHide))) {
      return;
    }

    var self = this;
    let elemid = '#dv_mg_' + this.firstQuestion.UniqueNumber;
    var widthArray = [];

    this.questionPositionHandle(elemid);

    this.GetTitleColumnWidth();

    $(elemid).find('.sub-category-table').each(function (i) {
      let currentValue = self.setColumnWidth($(this));
      widthArray.push(currentValue);
    });

    $(elemid).find('.sub-category-table').each(function (i) {
      $(this).find('.sub-category-td').css('width', widthArray[i] + 'px');
      $(this).find('.sub-category-td').css('min-width', widthArray[i] + 'px');
      // $(this).find('.gridInputTd').css('width', widthArray[i] + 'px');
      // $(this).find('.gridInputTd').css('min-width', widthArray[i] + 'px');
      let tableWidth = $(this).find('.sub-category-td').length * widthArray[i];
      $(this).css('width', tableWidth + 'px');
    });
    setTimeout(() => {
    if ($(elemid).find('.main-matrix-table').length > 0 && $(elemid).find('.main-matrix-table').outerWidth() < $(elemid).closest('.question-data').width()) {
      $(elemid).closest('.question-data').find('legend.matrix-question').outerWidth($(elemid).find('.main-matrix-table').outerWidth());
    }
    }, 0);

    setTimeout(() => {
      if ($(elemid).find('.answer-option-wrapper').outerWidth() > $(elemid).closest('.question-data').outerWidth()) {
        $(elemid).find('.div-scroll-btn').show();
      }
    }, 0);
    $(document).ready(function () {
      if(self.isSearchableDD)
      {
        $(elemid).find('.answer-option-wrapper').css('padding-bottom','70px');
        $(elemid).find('.answer-option-wrapper').addClass('GridSearch');
      }
      
      $(elemid).find('fieldset-wrapper-scroll').scroll(function () {
        if($('.RTLDir').length > 0) {
          if ($(this).find('.answer-option-wrapper').outerWidth() + $(this).scrollLeft() <= $(this).outerWidth() + 5) {
            $(this).parents('.divScroll').find('.div-scroll-btn').hide();
          } else if($(this).find('.answer-option-wrapper').outerWidth() + $(this).scrollLeft() > $(this).outerWidth() + 5) {
            $(elemid).parents('.divScroll').find('.div-scroll-btn').show();
          }
        } else {
          if ($(this).find('.answer-option-wrapper').outerWidth() - $(this).scrollLeft() <= $(this).outerWidth() + 5) {
            $(this).parents('.divScroll').find('.div-scroll-btn').hide();
          } else {
            $(this).parents('.divScroll').find('.div-scroll-btn').show();
          }
        }
      });

      $(window).on('resize', function() {
        $('.main-matrix-table').each(function() {
          if($(this).outerWidth() < $(this).closest('.question-data').width()) {
            $(this).closest('.question-data').find('legend.matrix-question').outerWidth($(this).outerWidth());
          } else {
            $(this).closest('.question-data').find('legend.matrix-question').outerWidth($(this).closest('.question-data').outerWidth() - 2);
          }
        });
      });
    });

    // $(document).click(function () {
    //   if (!$(event.target).parents().hasClass('drill-down-search')) {
    //     $('.drill-down-search').removeClass('showDrillList');
    //   }
    // });

    // if (this.questions[0].qtype == 'GR' || this.questions[0].qtype == 'RG' ||
    //   (this.questions[0].qtype == 'RW' && this.questions[0].qsubtype == 1)) {
    //   $('document').ready(function () {

    //     for (let i = 0; i < self.questions.length; i++) {
    //       if ($("#td_Q" + self.questions[i].qno + "_" + self.questions[i].UniqueNumber + "_R")) {
    //         for (let j = 0; j < self.questions[i].Answers.length; j++) {
    //           let radioid = "lbl_Q" + self.questions[i].qno + "_" + self.questions[i].UniqueNumber + "_R_" + self.questions[i].Answers[j].value_id + "_ID";
    //           $('#' + radioid).unbind().click(function (event) {
    //             if (self.questions[i].Answers[j].selectdId == 0) {
    //               self.RadioButtonClickEventHandling(self.questions[i].Answers[j], self.questions[i]);
    //               self.RadioButtonSelectedValue(self.questions[i].Answers[j], self.questions[i]);
    //             }
    //             else {
    //               self.RadioButtonClickEventHandling(self.questions[i].Answers[j], self.questions[i]);
    //             }
    //           });
    //         }
    //       }
    //     }
    //   });
    // }
    $('document').ready(function () {

      for (let i = 0; i < self.questions.length; i++) {
        if($('#div_MDD_drilldown_' + self.questions[i].UniqueNumber).find('input.drill-down-input').val() == "") {
          $('#div_MDD_drilldown_' + self.questions[i].UniqueNumber).find('input.drill-down-input').removeClass('no-search-icon');
        } else {
          $('#div_MDD_drilldown_' + self.questions[i].UniqueNumber).find('input.drill-down-input').addClass('no-search-icon');
        }
        let width=$('#div_MDD_drilldown_' + self.questions[i].UniqueNumber).width();
        $('.drill-down-list-itemMessage_'+self.questions[i].UniqueNumber).css('width',width + 'px');
      }
    });
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if(data) {
        this.isAnsChange =false;
      }
    });
  }

  ngOnDestroy(){
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  onLoadFilterObject(){
    this.questions = JSON.parse(this.JsonData);

      if (this.previewData != undefined && this.previewData.isPrevPgChnge &&
        this.questions[0].AnsPipeCondition != 0 && this.questions[0].AnsPipeCondition != 1 &&
        this.questions[0].AnsPipeCondition != 3 && this.questions[0].AnsPipeCondition != 4 &&
        this.questions.find(e => e.isMultiQuestionPiping) == undefined) {
        this.isDisplayedPipeMessage = true;
      } else {
        this.isDisplayedPipeMessage = false;
      }

      let imgQn
      if(this.isEx)
      {
        //this.isDisplayQno = true;
        imgQn = this.questions.find(e => e.sub_qno == 1 || e.population_type !=5);
      }
      else
      {
        imgQn = this.questions.find(e => e.sub_qno == 1);
      }

      if (imgQn != undefined && imgQn != null) {
        this.imgQuestion = imgQn;
      }

      let fstQn = this.questions[0];
      if (fstQn != undefined && fstQn != null) {
        this.firstQuestion = fstQn;
      }

      if (this.questions.find(e => e.AnsPipeCondition > 1) != undefined && this.isDisplayQno) {
        this.isAnswerPipingSubChar = true;
      } else {
        this.isAnswerPipingSubChar = false;
      }

      this.questions = this.questions.filter(e => e.population_type != 2 && e.population_type != 5);
      this.questions = this.questions.filter(e => !e.isMultiQuestionPiping);
  }

  remainingChar(question: Questions): number {

    if (question.AnswerText != null) {
      return question.characterLimit - question.AnswerText.length;
    }else{
      question.RemainingChr
      return question.characterLimit;
    }
  }


  SortQuestions(isLoading: boolean = true) {
    if (this.groups[0].answer_style != 2 && this.groups[0].answer_style != 1) {
      this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
    }else{
      this.questions.sort((n1, n2) => n1.qno - n2.qno && n1.sub_qno - n2.sub_qno);
    }
    let questionsArray = [];

    let standAloneQn = this.questions.find(e => e.qtype == 'SR' || e.qtype == 'SC');

    if (standAloneQn != null && standAloneQn != undefined && !this.isMobile) {
      this.isStandAloneGrid = true;
    }

    if (this.isMobile || this.isStandAloneGrid) {
      let unique = this.questions.map(e => e.qno).filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < unique.length; i++) {
        let questions = this.questions.filter(e => e.qno == unique[i]).sort((n1, n2) => n1.qno - n2.qno);

        if (questions.length > 0) {

          if (this.groups[0].answer_style == 2) {
            let unique_2 = this.questions.map(e => e.sub_qno).filter((value, index, self) => self.indexOf(value) === index);
            if (isLoading && i == 0) {
              unique_2 = CommonLogic.MatrixListRandom(unique_2);
              this.service.setMatrixRandomList(this.matrix.matrix_id, unique_2);
            } else {
              unique_2 = this.service.getMatrixRandomList(this.matrix.matrix_id);
            }

            let questions_2 = [];
            for (let k = 0; k < unique_2.length; k++) {
              questions_2.push(questions.find(e => e.sub_qno == unique_2[k]));
            }
            questions = questions_2;
          }

          if (this.isAnswerPipingSubChar) {
            for (let j = 0; j < questions.length; j++) {
              questions[j].subQnoinChar = CommonLogic.Convert_To_Alpha(j + 1)
            }
          }
          if(questions.filter(e=>((e.isGroupRule &&  e.isCQHide)||(e.isNOGroupRule &&  e.isGroupCQHide))).length == 0)
            questionsArray.push(questions);
        }
      }
    } else {
      let unique = this.questions.map(e => e.sub_qno).filter((value, index, self) => self.indexOf(value) === index);

      if (this.groups[0].answer_style != 1 && this.groups[0].answer_style != 2) {
        //unique.sort();
        unique.sort((a, b) => parseInt(a.toString()) - parseInt(b.toString()));
      } else if (this.groups[0].answer_style == 2) {
        if (isLoading) {
          unique = CommonLogic.MatrixListRandom(unique);
          this.service.setMatrixRandomList(this.matrix.matrix_id, unique);
        } else {
          unique = this.service.getMatrixRandomList(this.matrix.matrix_id);
        }
      }

      for (let i = 0; i < unique.length; i++) {
        let questions = this.questions.filter(e => e.sub_qno == unique[i]).sort((n1, n2) => n1.qno - n2.qno);

        if (questions.length > 0) {

          if (this.isAnswerPipingSubChar) {
            for (let j = 0; j < questions.length; j++) {
              questions[j].subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1)
            }
          }
          if(questions.filter(e=>e.isCQHide == true).length == 0)
            questionsArray.push(questions);
        }
      }
    }

    this.questionsArray = questionsArray;
  }

  BranchingQuestionsHandling(isLoading: boolean = false) {
    let sourceGridQuestions = this.questions.filter(e => e.group_no == this.matrix.SourceGrid);

    if (sourceGridQuestions != null && sourceGridQuestions.length > 0) {

      let target = this.matrix.TargetGrid.toString().split(',');

      for (let i = 0; i < sourceGridQuestions.length; i++) {

        for (let j = 0; j < target.length; j++) {
          let targetQuestions = this.questions.filter(
            e => e.group_no == parseInt(target[j]) && e.sub_qno == sourceGridQuestions[i].sub_qno);

          for (let k = 0; k < targetQuestions.length; k++) {

            if (sourceGridQuestions[i].selectAnsValue > 0) {

              if (sourceGridQuestions[i].selectAnsValue > 0) {

                if (this.matrix.SourcePosition == 1) {
                  if (this.matrix.SourceNumber == sourceGridQuestions[i].selectAnsValue) {
                    this.EnabledAndDisabledQuestion(targetQuestions[k], false, isLoading);
                  }
                  else {
                    this.EnabledAndDisabledQuestion(targetQuestions[k], true, isLoading);
                  }
                } else if (this.matrix.SourcePosition == 2) {
                  if (sourceGridQuestions[i].selectAnsValue <= this.matrix.SourceNumber) {
                    this.EnabledAndDisabledQuestion(targetQuestions[k], false, isLoading);
                  }
                  else {
                    this.EnabledAndDisabledQuestion(targetQuestions[k], true, isLoading);
                  }
                } else if (this.matrix.SourcePosition == 3) {
                  if (sourceGridQuestions[i].selectAnsValue >= this.matrix.SourceNumber) {
                    this.EnabledAndDisabledQuestion(targetQuestions[k], false, isLoading);
                  }
                  else {
                    this.EnabledAndDisabledQuestion(targetQuestions[k], true, isLoading);
                  }
                }
              }
            } else {
              this.EnabledAndDisabledQuestion(targetQuestions[k], true, isLoading);
            }
          }
        }
      }
    }
  }

  EnabledAndDisabledQuestion(question: Questions, isDisabled: boolean, isLoading: boolean) {
    if (isDisabled) {
      question.IsDisabled = true;

      if (question.isValid) {
        question.isValid = false;
      }

      if (question.AnswerText != null) {
        question.AnswerText = null;

        if (question.qtype == 'GD' || (question.qtype == 'RW' && question.qsubtype == 2)) {
          question.selectAnsValue = -1;
        } else {
          question.selectAnsValue = 0;
        }

        question.AnswerID = 0;
        question.selectedOptionList = [];

        if (question.Answers != null) {
          for (let i = 0; i < question.Answers.length; i++) {
            question.Answers[i].ControlAns = null;
          }
        }
      }
    } else {
      question.IsDisabled = false;
    }

    if (!isLoading) {
      //this.ChangeAnswersData.emit(question);
      this.UpdateChangeAnswersData(question);
    }
  }

  RandomAnswerHandling(question: Questions) {
    let currentIndex = question.Answers.length, temporaryValue, randomIndex;
    let updateItem = question.Answers.find(e => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      currentIndex -= 1;
    }

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = question.Answers[currentIndex];
      question.Answers[currentIndex] = question.Answers[randomIndex];
      question.Answers[randomIndex] = temporaryValue;
    }
  }

  GetQuestionsString(question): string {

    if (this.GetGroupData(question.group_no).mgTextboxHeight > 1) {
      question.tHeight = this.GetGroupData(question.group_no).mgTextboxHeight;
    }

    if (question.AnswerText == null && question.mandatory) {
      question.isMandatoryInvalid = true;
    } else {
      question.isMandatoryInvalid = false;
    }

    return JSON.stringify(question);
  }

  GetQuestionNumber(group_no: number): number {
    if (this.questions != null) {
      return this.questions.find(e => e.group_no == group_no).qno;
    }
  }

  GetColumnWidth(group_no: number): number {
    if (this.groups != null) {
      var elemId = '#dv_' + this.firstQuestion.UniqueNumber;
      var fullWidth = $(elemId).find('.fieldset-wrapper').outerWidth();
      var totalWidth = (this.groups.find(e => e.group_no == group_no).colwidth/100) * fullWidth;
      return totalWidth;
    }
  }

  GetTitleColumnWidth(){
    if (this.matrix != null) {
      var elemId = '#dv_' + this.firstQuestion.UniqueNumber;
      var fullWidth = $(elemId).find('.fieldset-wrapper').outerWidth();
      if(this.matrix.subq_col_width == 0){
        if(this.firstQuestion.uniform_width)
        {
          totalWidth = 253;
        } else {
          var maxTitleWidth = 0;
          $(elemId).find('.matrixTitleTd').css('white-space', 'nowrap');
          $(elemId).find('.matrixTitleTd').each(function(i) {
            if($(this).outerWidth() > maxTitleWidth){
              maxTitleWidth = $(this).outerWidth();
            }
          });

          if(maxTitleWidth > 253){
            maxTitleWidth = 253;
          }
          var totalWidth = maxTitleWidth;
          $(elemId).find('.matrixTitleTd').css('white-space', 'normal');
        }
      } else {
        var totalWidth = ((this.matrix.subq_col_width/100) * fullWidth);
      }
      $(elemId).find('.matrixTitleTd').css('width', totalWidth + 'px');
      $(elemId).find('.matrixTitleTd').css('min-width', totalWidth + 'px');
    }
  }

  GetTotalColumnWidth(): number {
    if (this.matrix != null) {
      var elemId = '#dv_' + this.firstQuestion.UniqueNumber;
      var fullWidth = Math.ceil($(elemId).find('.fieldset-wrapper').outerWidth());
      var totalWidth = (this.matrix.totalwidth/100) * fullWidth;
      if(totalWidth == 0){
        totalWidth = fullWidth;
      }
      return (totalWidth - 1);
    }
  }

  GetVerticalSpace(): string {
    if (this.matrix != null) {

      switch (this.matrix.VerticalSpaceCount) {
        case 0:
          return "15px";
          break;
        case 1:
          return "30px";
          break;
        case 2:
          return "45px";
          break;
        case 3:
          return "60px";
          break;
        default:
          break;
      }
    }
  }

  GetColumnSpan(group_no: number): number {
    if (this.questions != null) {
      let question = this.questions.find(e => e.group_no == group_no);

      if (question.qtype == 'T' || question.qtype == 'GD' || (question.qtype == 'RW' && question.qsubtype == 2)) {
        return 1;
      } else {
        return question.Answers.length;
      }
    }
  }

  GetGroupTitle(group_no: number): string {
    if (this.groups != null) {
      return this.groups.find(e => e.group_no == group_no).gtitle;
    }
  }

  GetGroupData(group_no: number): Group {
    if (this.groups != null) {
      return this.groups.find(e => e.group_no == group_no);
    }
  }

  UpdateChangeAnswersData(question: Questions) {
    if(question.AnswerText!=null){
      this.isAnsChange = true;
    }
    this.ChangeAnswersData.emit(question);
  }

  UpdateQuestionsData(question: Questions) {
    this.UpdateChangeAnswersData(question);
    let qn = this.questions.find(e => e.UniqueNumber == question.UniqueNumber);
    this.questions[this.questions.indexOf(qn)] = question;

    if (this.matrix.isBranchEnabled) {
      this.BranchingQuestionsHandling();
    }
  }

  RadioButtonSelectedValue(answer: Answers, question: Questions) {

    if(answer.selectdId == 1){
      this.RadioButtonClickEventHandling(answer, question);
    }
    else{
      for (let i = 0; i < question.Answers.length; i++) {
        if (answer.ms_id === question.Answers[i].ms_id) {
          answer.ControlAns = answer.value_text;
          answer.selectdId = 1;
          question.Answers[i] = answer;
          question.AnswerID = answer.ms_id;
          question.selectAnsValue = answer.value_id;
          question.AnswerText = answer.ControlAns;
          question.pageto = answer.pageto;
          question.otherAnswer = null;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (answer.isOther) {
            question.isOtherAnswer = true;
          }
          else {
            question.isOtherAnswer = false;
          }
        }
        else {
          question.Answers[i].ControlAns = null;
          question.Answers[i].selectdId = 0;
        }
      }
      //this.ChangeAnswersData.emit(question);
      this.changeDetect.detectChanges();
      this.UpdateChangeAnswersData(question);

      if (this.matrix.isBranchEnabled) {
        this.BranchingQuestionsHandling();
      }
    }

  }

  RadioButtonClickEventHandling(answer: Answers, question: Questions) {
    if (answer.selectdId == 0) {
      return;
    }

    if (this.questions != null) {
      answer.selectdId = 0;
      answer.ControlAns = null;
      let updateItem = question.Answers.find(e => e.ms_id == answer.ms_id);
      let index = question.Answers.indexOf(updateItem);
      question.Answers[index] = answer;
      question.AnswerID = 0;
      question.selectAnsValue = 0;
      question.pageto = 0;
      question.AnswerText = null;
      question.otherAnswer = null;
      question.isOtherAnswer = false;
      this.changeDetect.detectChanges();
      //this.ChangeAnswersData.emit(question);
      this.UpdateChangeAnswersData(question);

      if (this.matrix.isBranchEnabled) {
        this.BranchingQuestionsHandling();
      }

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = false;
      }
    }
  }

  CheckBoxSelectedValue(answer: Answers, event: any, question: Questions) {

    question.isAlertDanger = false;

    let updateItem = question.Answers.find(e => e.ms_id == answer.ms_id);
    let index = question.Answers.indexOf(updateItem);

    if (event) {
      this.AddSelectedValueList(answer, question);
      answer.selectdId = 1;
      question.Answers[index] = answer;
      question.pageto = answer.pageto;
      question.otherAnswer = null;

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = true;
      }

      if (answer.isOther) {
        question.isOtherAnswer = true;
      }
    }
    else {
      this.RemoveSelectedList(answer, question);

      answer.selectdId = 0;
      answer.ControlAns = null;

      if (answer.IsNoneAbove) {
        question.isValid = false;
      }

      question.Answers[index] = answer;
      question.AnswerID = 0;
      question.selectAnsValue = 0;
      question.pageto = 0;

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = false;
      }

      if (answer.isOther) {
        question.isOtherAnswer = false;
        question.otherAnswer = null;
      }
    }

    if (question.selectedOptionList.length > 0) {
      question.AnswerText = "Selected Answer Option";
    } else {
      question.AnswerText = null;
    }

    //this.ChangeAnswersData.emit(question);
    this.changeDetect.detectChanges();
    this.UpdateChangeAnswersData(question);
  }

  AddSelectedValueList(answer: Answers, question: Questions) {

    let selectedOptionList: SelectedOptionList[];

    if (question.selectedOptionList != null && question.selectedOptionList != undefined) {
      selectedOptionList = question.selectedOptionList;
    } else {
      selectedOptionList = [];
    }

    selectedOptionList.push(
      { value_id: answer.value_id, value_text: answer.value_text, isOther: answer.isOther });

    question.selectedOptionList = selectedOptionList;
  }

  RemoveSelectedList(answer: Answers, question: Questions) {

    let selectedOptionList: SelectedOptionList[];

    if (question.selectedOptionList != null && question.selectedOptionList != undefined) {
      selectedOptionList = question.selectedOptionList;
      let selectedList = selectedOptionList.find(e => e.value_id == answer.value_id);
      let curIndex = selectedOptionList.indexOf(selectedList);

      if (curIndex >= 0) {
        selectedOptionList.splice(curIndex, 1);
      }
    } else {
      selectedOptionList = [];
    }
    question.selectedOptionList = selectedOptionList;
  }

  DropDownSelectedValue(event: any, question: Questions,isSearchableDD: boolean = false,curVal: number = -1) {

    let value = event.target.value;
    if(isSearchableDD){
      value = curVal;
    }

    if (value === "-1" || !value) {
      question.isOtherAnswer = false;
      question.selectAnsValue = -1;
      question.AnswerID = 0;
      question.AnswerText = null;

      if (question.Answers.find(e => e.selectdId == 1) != undefined) {
        question.Answers.find(e => e.selectdId == 1).selectdId = 0;
        question.Answers.find(e => e.selectdId == 1).ControlAns = null;
      }
    } else {
      for (let i = 0; i < question.Answers.length; i++) {
        if (value == question.Answers[i].value_id) {
          event.selectdId = 1;
          question.Answers[i].selectdId = 1;
          question.AnswerID = question.Answers[i].ms_id;
          question.selectAnsValue = question.Answers[i].value_id;
          question.AnswerText = question.Answers[i].value_text;
          question.pageto = question.Answers[i].pageto;
          question.otherAnswer = null;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (question.Answers[i].isOther) {
            question.isOtherAnswer = true;
          }
          else {
            question.isOtherAnswer = false;
          }
        }
        else {
          question.Answers[i].ControlAns = null;
          question.Answers[i].selectdId = 0;
        }
      }
    }

    //this.ChangeAnswersData.emit(question);
    this.UpdateChangeAnswersData(question);
  }

  keytab_remainingChar(event: any, curVal: string, question: Questions) {
    if (question.Showcharlimit || this.isEx) {
      let remainingCharacters = question.characterLimit - curVal.length;
    }
  }

  onBlurMethod(question: Questions) {

    // if (question.AnswerText == "") {
    //   question.AnswerText = null;
    // }

    if (question.AnswerText != null && question.AnswerText.replace(/\s/g, '') == "") {
      question.AnswerText = null;
      question.pageto = 0;
    }
    else
    {
      question.pageto = question.Answers[0].pageto;
    }



    //this.ChangeAnswersData.emit(question);
    this.UpdateChangeAnswersData(question);
  }

  ValidationForSubQuestionType(event: any, curVal: any, question: Questions) {

    if (curVal == "") {
      question.isValid = false;
      question.AnswerText = null;

      if (question.qsubtype == 31) {
        question.isReEnterEmailValid = false;
      }
      question.pageto=0;
      //this.ChangeAnswersData.emit(question);
      this.UpdateChangeAnswersData(question);
      return;
    }

    if (question.qsubtype == 21) {
      if(curVal.indexOf(" ") == -1){
        this.NumberValidation(event, curVal, question);
      } else{
        question.isValid = true;
      }
    }
    else if (question.qsubtype == 31) {
      this.EmailValidation(curVal, question);
    }
    question.pageto=question.Answers[0].pageto;
    //this.ChangeAnswersData.emit(question);
    this.UpdateChangeAnswersData(question);
  }

  keyup(question: Questions) {
    question.isValid = false;
  }

  EmailValidation(curVal: string, question: Questions) {
    const regexp = new RegExp(/^([a-zA-Z0-9_\.\'\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z])+$/);
    let isValid = regexp.test(curVal);

    if (isValid) {
      question.isValid = false;
    } else {
      question.isValid = true;
    }
  }

  NumberValidation(event: any, curVal: any, question: Questions) {
    let curValue1 = parseFloat(curVal);
    let min1 = parseFloat(question.num_range_1);
    let max1 = parseFloat(question.num_range_2);

    if (curVal != "") {
      if (isNaN(curVal) || (curValue1 < min1 || curValue1 > max1)) {
        question.isValid = true;
        return;
      }
      else {
        question.isValid = false;

        if (question.AllowOnlyInteger) {
          //question.AnswerText = Math.round(curVal).toString();

          if (Number.isInteger(curValue1) &&  curVal.indexOf('.') < 0) {
            question.isValid = false;
          } else {
            question.isValid = true;
          }
        }
      }
    } else {
      question.isValid = true;
    }
  }

  RatingScaleHeaderText(question: Questions, index: number, answer: Answers): string {

    let groupData = this.groups.find(e => e.group_no == question.group_no);

    if (groupData != undefined && groupData != null) {

      if (answer.value_id == 1) {
        return groupData.L_text;
      } else if (groupData.M_Pos == parseInt(answer.value_text)) {
        return groupData.M_text;
      } else {
        let max = question.Answers.reduce((prev, current) => (prev.value_id > current.value_id) ? prev : current);
        if (max != null && max != undefined) {
          if (max.weight == 0) {
            if (answer.value_text == "") {
              return 'N/A';
            } else if (answer.value_text != null) {
              if ((max.value_id - 1) == (answer.value_id) && answer.weight != null && answer.weight != 0) {
                return groupData.H_text;
              } else if (answer.value_text != null && max.value_id == answer.value_id) {
                let value: any = answer.value_text;
                if (answer.value_text.indexOf('N/A') < 0) {
                  answer.value_text = value + ' ' + 'N/A';
                }
                return '';
              }
            }
          }
          else if (max.value_id == answer.value_id && answer.weight != 0) {
            return groupData.H_text;
          }
        }
      }

      // if (index == 0) {
      //   return groupData.L_text;
      // } else if (groupData.M_Pos == parseInt(answer.value_text)) {
      //   return groupData.M_text;
      // } else if ((index) == question.Answers.length - 2) {
      //   let max = question.Answers.reduce((prev, current) => (prev.value_id > current.value_id) ? prev : current);

      //   if (max != null && max != undefined) {
      //     if (max.weight == 0) {
      //       return groupData.H_text;
      //     }
      //     else {
      //       return;
      //     }
      //   }
      // }
      // else if ((index + 1) == question.Answers.length) {
      //   if (answer.weight != null && answer.weight != 0) {
      //     return groupData.H_text;
      //   } else {
      //     if (answer.value_text == "") {
      //       return 'N/A';
      //     } else if (answer.value_text != null) {
      //       return;
      //     }
      //   }
      // }
    }
    return '';
  }

  GetAnswerHeader(group_no: number): Answers[] {
    if (this.questions != null) {
      let question = this.questions.find(e => e.group_no == group_no);
      if (question.qtype != 'T' && question.qtype != 'GD' &&
        !(question.qtype == 'RW' && question.qsubtype == 2)) {
        return question.Answers;
      } else {
        return;
      }
    }
  }

  GetQuestion(group_no: number): Questions{
    return this.questions.find(e => e.group_no == group_no);
  }

  setColumnWidth(obj){
    let maxWidth = 0;
    obj.find('.sub-category-td').each(function() {
      if($(this).hasClass('matrixRatingTd')){
        if($(this).outerWidth() > maxWidth){
          maxWidth = $(this).outerWidth();
        }
      } else {
        if($(this).outerWidth() > maxWidth){
          maxWidth = $(this).width();
        }
      }
    });

    if(maxWidth > 148){
      maxWidth = 148;
    }

    return maxWidth;
  }

  getMatrixTitle(matrix_id: number) : string{
    return this.service.getMatrixPiping(matrix_id);
  }

  questionPositionHandle(objId: any) {
    let unique = this.questions.map(e => e.sub_qno).filter((value, index, self) => self.indexOf(value) === index);

    if (this.groups[0].answer_style != 1 && this.groups[0].answer_style != 2) {
      //unique.sort();
      unique.sort((a, b) => parseInt(a.toString()) - parseInt(b.toString()));
    } else if (this.groups[0].answer_style == 2) {
      unique = this.service.getMatrixRandomList(this.matrix.matrix_id);
    }
    //unique.sort((n1, n2) => n1 - n2);

    for (let i = 0; i < 2; i++) {
      this.setTitleColumnPos(objId, this.matrix.QPos, '', '', i,'',null);
    }
    for (let i = 0; i < unique.length; i++) {
      let questions = this.questions.filter(e => e.sub_qno == unique[i]);
      if (questions.length > 0 && questions.filter(e=>e.isCQHide).length > 0) {
        unique.splice(i,1);
        i--;
      }
    }

    for (let i = 0; i < unique.length; i++) {
      
      let questions = this.questions.filter(e => e.sub_qno == unique[i]);
      if (questions.length > 0) {
        var arrayNum =  this.isDisplayQno && this.groups[0].answer_style != 2 ? questions[0].subQnoinChar: this.isDisplayQno && this.groups[0].answer_style == 2 ? CommonLogic.Convert_To_Alpha(i + 1) : '';
        var arrayTitle = questions[0].piping ? questions[0].pipingQuationTitle : questions[0].qtitle;
        var questionID = "lbl_MG_" + questions[0].UniqueNumber + "_SubQ"
        this.setTitleColumnPos(objId, this.matrix.QPos, arrayTitle, arrayNum, i + 2,questionID,questions[0]);
      }
    }
  }

  setTitleColumnPos(obj: any, qpos: number, arrayTitle: string, subQ: string, index: number,questionID: string,Questions:Questions) {
    var SubQString = ''
    if(this.isDisplayQno)
    {
      //SubQString =  '<span style="display: inline-block;"' + subQ + '</span> '
      if(subQ != ''){
        subQ = subQ + ' ';
      }
      SubQString =  '<span>'+ subQ + '</span>'
    }

    if (qpos == 0) {
      if ($(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(0).hasClass("matrixTitleTd")) {
        $(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(qpos).remove();
      }

      if (index == 0 || index == 1) {
        $(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(qpos).before('<td class="matrixTitleTd"></td>');
      } else {

          if (Questions != null && (this.groups.length == 1 && Questions.mandatory && this.isMandatoryUpfront) || (this.groups.length == 1 && Questions.mandatory && this.isSubmitted && Questions.AnswerText == null))
          {
            $(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(qpos).before('<td class="matrixTitleTd matrixMandatory" style="padding: 10px 0;position:relative;" >' +
          '<div><div class="isMandatory matrix-grid-mandatory"></div></div>'+
          SubQString +
          '<span id=' + questionID +'>' + arrayTitle + '</span>' +
          '</td>');
          }
          else
          {
            $(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(qpos).before('<td class="matrixTitleTd" style="padding: 10px 0;" >' +
            SubQString +
          '<span id=' + questionID +'>' + arrayTitle + '</span>' +
          '</td>');
          }

      }
    } else {

      qpos = qpos - 1;
      if ($(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(qpos + 1).hasClass("matrixTitleTd")) {
        $(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(qpos + 1).remove();
      }

      if (index == 0 || index == 1) {
        $(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(qpos).after('<td class="matrixTitleTd" style="padding-left: 15px;"></td>');
      } else {

        if (Questions != null && (this.groups.length == 1 && Questions.mandatory && this.isMandatoryUpfront) || (Questions.mandatory && this.isSubmitted && Questions.AnswerText == null))
          {
          $(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(qpos).after('<td class="matrixTitleTd matrixMandatory grid-border grid-border-inverse" style="padding: 10px 0 10px 15px;position:relative;" >' +
          '<div><div class="isMandatory matrix-grid-mandatory "></div></div>'+
          SubQString +
          '<span id=' + questionID +'>' + arrayTitle + ' </span>' +
          '</td>');
        }
        else
        {
          $(obj).find('.answer-option-wrapper.matrix-grid > table > tr').eq(index).children('td').eq(qpos).after('<td class="matrixTitleTd grid-border grid-border-inverse" style="padding: 10px 0 10px 15px;" >' +
          SubQString +
          '<span id=' + questionID +'>' + arrayTitle + ' </span>' +
          '</td>');
        }

      }
    }
  }

  ngOnChangesEventHandle(no: number) {
    if (no == this.questionsArray.length - 1) {
        this.ngAfterViewInit();
        this.count++;
    }
  }

  setLastRowPadding() {
    let elemid = this.firstQuestion.UniqueNumber + '_table';

    for (let i = 0; i < this.questionsArray[this.questionsArray.length - 1].length; i++) {
      let qn = this.questionsArray[this.questionsArray.length - 1][i];

      if (qn.isValid && qn.qtype == 'T') {
        $('#'+elemid).addClass('a-strip-bottom-table');
        return;
      }
    }

    $('#'+elemid).removeClass('a-strip-bottom-table');
    return;
  }

  setDrillDownValue(event: any, question: Questions, self, curVal: number) {
    self.DropDownSelectedValue(event, question,true,curVal);
    if($('#div_MDD_drilldown_' + question.UniqueNumber).find('input.drill-down-input').val() == "") {
      $('#div_MDD_drilldown_' + question.UniqueNumber).find('input.drill-down-input').removeClass('no-search-icon');
    } else {
      $('#div_MDD_drilldown_' + question.UniqueNumber).find('input.drill-down-input').addClass('no-search-icon');
    }
  }

  showDDList(event) {
    if ($(event.target).parents().hasClass('showDrillList')) {
      $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      $(event.target).closest('.drill-down-input').attr("aria-expanded", "false");
    } else {
      $('.drill-down-search').removeClass('showDrillList');
      $(event.target).closest('.drill-down-search').addClass('showDrillList');
      $(event.target).closest('.drill-down-search').find('.drill-down-input').focus();
      $(event.target).closest('.drill-down-search').find('.drill-down-list-item').show();
      $(event.target).closest('td').css('z-index', '2');
    }
  }

  selectDDListItem(event, question: Questions) {
    var self = this;
    $(event.target).closest('.drill-down-search').find('.drill-down-input').val('');
    $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
      $(this).html($(this).attr('ogListValue'));
      $(this).show();
      $(this).html(self.highlight($(this).html(), ''));
    });
    let itemText = $(event.target).attr('ogListValue');
    let itemValue = $(event.target).attr('list-value');
    $(event.target).closest('.drill-down-search').find('select').val(itemValue);
    $(event.target).closest('.drill-down-search').find('.drill-down-input').val(itemText);
    $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    $(event.target).closest('td').css('z-index', '0');
    self.checkDrillDown = 1;
    self.setDrillDownValue(event, question, self,itemValue);
  }

  setDDListItem(event, question: Questions) {
    var self = this;
    setTimeout(function () {
      if (self.checkDrillDown == 0 && self.checkDrillDown != undefined) {
        const ddSearchValue = $(event.target).val().toLowerCase();
        // const currentInput = $(this);
        if (ddSearchValue !== '') {
          $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
            $(this).html($(this).attr('ogListValue'));
            if (ddSearchValue === $(this).text().toLowerCase()) {
              $(event.target).val($(this).attr('ogListValue'));
              // $(event.target).closest('.drill-down-search').removeClass('showDrillList');
              $(event.target).closest('td').css('z-index', '0');
              const itemValue = $(this).attr('list-value');
              $(this).closest('.drill-down-search').find('select').val(itemValue);
              self.setDrillDownValue(event, question, self,itemValue);
              return false;
            } else {
              $(event.target).val('');
              $(this).closest('.drill-down-search').find('select').val('0');
              question.AnswerText = null;
              self.setDrillDownValue(event, question, self,-1);
            }
          });
        } else {
          question.AnswerText = null;
          self.setDrillDownValue(event, question, self,-1);
        }
      }
    }, 0);
    // $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    $(event.target).closest('td').css('z-index', '0');
    setTimeout(function () {
      $('.drill-down-list-itemMessage_'+question.UniqueNumber).hide();
    }, 1);
  }

  filterDDSearch(event, question: Questions) {
    var self = this;
    var keyCode = event.keyCode || event.which;
    if(keyCode == 13 || keyCode == undefined){
      event.preventDefault();
      $(event.target).blur();
      setTimeout(function (){
        $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      }, 100);
    }
    setTimeout(function () {
      var keyCode = event.keyCode || event.which;
      if(keyCode !== 9){
        $(event.target).closest('.drill-down-search').addClass('showDrillList');
        if(keyCode == 40){
          event.preventDefault();
          if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'))){
            $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'));
            $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
            $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').addClass('currentActiveDDITem');
            $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
          } else {
            var nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').nextAll('.drill-down-list-item:visible:first');
            if(nextElement.length > 0){
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              nextElement.addClass('currentActiveDDITem');
            } else {
              nextElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(nextElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              nextElement.addClass('currentActiveDDITem');
            }
          }

          var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
          var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
          var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
          var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

          if(elementPosWithHt > scrollableDivPosWithHt){
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
          } else if(elementPos < scrollableDivPos) {
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
          }

        } else if(keyCode == 38) {
          event.preventDefault();
          if($(event.target).closest('.drill-down-search').find('select').val() <= 0 || $(event.target).closest('.drill-down-search').find('select').val() == parseInt($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:first').attr('list-value'))){
            $(event.target).closest('.drill-down-search').find('select').val($(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').attr('list-value'));
            $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
            $(event.target).closest('.drill-down-search').find('.drill-down-list .drill-down-list-item:visible:last').addClass('currentActiveDDITem');
            $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
          } else {
            // $(event.target).closest('.drill-down-search').find('select').val(parseInt($(event.target).closest('.drill-down-search').find('select').val()) - 1);
            // $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());

            var prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').prevAll('.drill-down-list-item:visible:first');
            if(prevElement.length > 0){
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              prevElement.addClass('currentActiveDDITem');
            } else {
              prevElement = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem');
              $(event.target).closest('.drill-down-search').find('select').val(parseInt(prevElement.attr('list-value')));
              $(event.target).val($(event.target).closest('.drill-down-search').find('select option:selected').text());
              $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
              prevElement.addClass('currentActiveDDITem');
            }
          }
          var elementPos = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top;
          var elementPosWithHt = $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').offset().top + $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').outerHeight();
          var scrollableDivPos = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top;
          var scrollableDivPosWithHt = $(event.target).closest('.drill-down-search').find('.drill-down-list').offset().top + $(event.target).closest('.drill-down-search').find('.drill-down-list').outerHeight();

          if(elementPosWithHt > scrollableDivPosWithHt){
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() + (elementPosWithHt - scrollableDivPosWithHt));
          } else if(elementPos < scrollableDivPos) {
            $(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop($(event.target).closest('.drill-down-search').find('.drill-down-list').scrollTop() - (scrollableDivPos - elementPos));
          }
        } else {
          $(event.target).closest('td').css('z-index', '2');
          $(event.target).closest('.drill-down-search').find('.currentActiveDDITem').removeClass('currentActiveDDITem');
          $(event.target).closest('.drill-down-search').find('select').val('-1');
          const ddSearchValue = $(event.target).val().toLowerCase();
          if (ddSearchValue !== '') {
            var isShowmessage=false;
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
              $(this).html($(this).attr('ogListValue'));
              if ($(this).text().toLowerCase().indexOf(ddSearchValue) !== -1) {
                $(this).show();
                $(this).html(self.highlight($(this).html(), ddSearchValue));
                isShowmessage=true;
              } else {
                $(this).hide();
              }
            });
            if(!isShowmessage){
              $('.drill-down-list-itemMessage_'+question.UniqueNumber).show();
            }else{
              $('.drill-down-list-itemMessage_'+question.UniqueNumber).hide();
            }
            if ($(event.target).closest('.drill-down-search').find('.drill-down-list-item:visible').length === 0) {
              $(event.target).closest('.drill-down-search').removeClass('showDrillList');
              $(event.target).closest('td').css('z-index', '0');
            } else {
              $(event.target).closest('.drill-down-search').addClass('showDrillList');
              $(event.target).closest('td').css('z-index', '2');
            }
          } else {
            $('.drill-down-list-itemMessage_'+question.UniqueNumber).hide();
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').show();
            $(event.target).closest('.drill-down-search').find('.drill-down-list-item').each(function () {
              $(this).html($(this).attr('ogListValue'));
            });
          }
          if($(event.target).val() != self.prevValue){
            self.checkDrillDown = 0;
          } else {
            self.checkDrillDown = 1;
          }
        }
      } else {
        $(event.target).closest('.drill-down-search').removeClass('showDrillList');
      }
    }, 1);
  }


  setPrevValue(event){
    this.prevValue = $(event.target).val();
  }

  highlight(s, search) {
    return s.replace(new RegExp(
      search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'
    ), '<b>$&</b>');
  }

  nextQuestion(event) {
    if (this.isNewParticipation && (this.surveyFormat == 1 ||this.surveyFormat == 2) && this.MatrixQCount == 1 && this.service.isAutoScroll) {
      // var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
      // if (nextbtnLength > 0) {
      //   var elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
      //   $('html,body').animate({
      //     scrollTop: (elemPosition - $(window).height() / 3)
      //   }, 400);
      // } else {
      //   var scrollVal = $('.tblPageFooter').offset().top;
      //   $('html,body').animate({
      //     scrollTop: scrollVal
      //   }, 400);
      // }
      // $(event).closest('.main-ques-cont').find('.ques-response-btn-div').hide();

      this.service.gotoNextQuestion(this.questions[0],event);
    }
  }

  gotoNextQuestion(question: Questions, event) {
    if (this.questions.filter(e => e.isValid).length == 0) {
      this.service.gotoNextQuestion(question, event);
    }
  }

   gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }


  closeDDList(event) {
    if(event.target.value !== "") {
      event.target.value = ""
    }
    $(event.target).closest('.drill-down-search').removeClass('showDrillList');
    $(event.target).attr("aria-expanded","false");
  }

  getAnswerPipeMessage(): string{
    return this.service.getAnswerPipeMessage();
  }

  getHiddenQuestions(questions:Questions[],service: ParticipationDataService)
  {
    
      return (questions.filter(e=> e.isCQHide==true).length == 0);
  }

}
